// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f05c4c2","396":"a90641fc","455":"4612f249","977":"358728ac"}[chunkId] + ".chunk.js";
};